import React from "react";
import { getRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CheckIconBlack } from "../../icons";
import PenIcon from "components/icons/PenIcon";

const { DateTime } = require("luxon");

class RakutenCommissionData extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            commissions: [],
            commissionsLoading: false,
            affiliateCommissionId: this.props.affiliateCommissionId,
            affiliateCommissionIdError: false,
            CommissionsTable: {
                title: "Affiliate commissions",
                options: {
                    selectableRows: "multiple",
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'commissionName',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    typography: {
                        fontFamily: "'Urbanist', 'sf_pro_displayregular', sans-serif",
                    },
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                        MUIDataTableBody: {
                            emptyTitle: {
                                textAlign: 'left',
                                paddingLeft: '385px',
                                paddingTop: '12px',
                                verticalAlign: 'top',
                                fontFamily: "'Urbanist', sans-serif",
                                fontSize: '16px',
                            }
                        }
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });

        if (!!(this.props.affiliateCommissionId)) {
            this.getCommissions();
        }
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (!!(this.props.affiliateCommissionId) && prevProps.affiliateCommissionId !== this.props.affiliateCommissionId){
            this.getCommissions();
        }
    }

    getCommissions = async () => {
        if (!(this.props.affiliateCommissionId)){
            this.setState({ affiliateCommissionIdError: true });
        }
                    console.log("in")

        let url = `/api/Merchant/GetRakutenCommissionRawDataById?id=` + this.props.affiliateCommissionId;

        this.setState({ commissionsLoading: true, affiliateCommissionIdError: false });

        try {
            const commissions = await getRequest(url);

            this.setState({
                commissions,
                commissionsLoading: false,
            });
        } catch (error) {
            console.error("Error fetching commissions:", error);
            this.setState({ commissions: [], commissionsLoading: false });
        }
    };

    onTabChange = (tab) => {
        this.setState({ tab });
    }

    render() {
        const columns = [
            {
                name: "rakutenCommissionId",
                label: "Rakuten Commission ID",
                options: { filter: true, sort: true }
            },
            {
                name: "eTransactionId",
                label: "E-Transaction ID",
                options: { filter: true, sort: true }
            },
            {
                name: "rakutenCommissionCreatedDate",
                label: "Commission Created Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false): "-"}</span>
                    )
                }
            },
            {
                name: "id",
                label: "Commission History ID",
                options: { filter: true, sort: true }
            },
            {
                name: "userId",
                label: "User ID",
                options: { filter: true, sort: true }
            },
            {
                name: "advertiserId",
                label: "Advertiser ID",
                options: { filter: true, sort: true }
            },
            {
                name: "orderId",
                label: "Order ID",
                options: { filter: true, sort: true }
            },
            {
                name: "sku",
                label: "SKU",
                options: { filter: true, sort: true }
            },
            {
                name: "productName",
                label: "Product Name",
                options: { filter: true, sort: true }
            },
            {
                name: "saleAmount",
                label: "Sale Amount",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>
                    )
                }
            },
            {
                name: "commissions",
                label: "Commissions",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>
                    )
                }
            },
            {
                name: "processDate",
                label: "Process Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>
                    )
                }
            },
            {
                name: "transactionDate",
                label: "Transaction Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>
                    )
                }
            },
            {
                name: "u1",
                label: "U1",
                options: { filter: true, sort: true }
            },
            {
                name: "currency",
                label: "Currency",
                options: { filter: true, sort: true }
            },
            {
                name: "commissionStatus",
                label: "Commission Status",
                options: { filter: true, sort: true }
            },
            {
                name: "createdBy",
                label: "Created By",
                options: { filter: true, sort: true }
            },
            {
                name: "createdDate",
                label: "Created Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>
                    )
                }
            },
            {
                name: "modifiedBy",
                label: "Modified By",
                options: { filter: true, sort: true }
            },
            {
                name: "modifiedDate",
                label: "Modified Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>
                    )
                }
            }
        ];



        return (
            <div>
                <ThemeProvider theme={this.state.CommissionsTable.getTheme()}>
                    <MUIDataTable
                        title={
                            <div style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                <p style={{ fontSize: '22px', marginTop: "20px" }}>{this.props.affiliateProgramManager?.name + " commissions by ID" ?? "No affiliate selected"}</p>
                                <p style={{ fontSize: '16px', marginTop: "10px", color: "red", display: this.state.affiliateCommissionIdError ? "" : "none" }}>Enter an affiliate commission ID</p>                                
                            </div>
                        }
                        data={this.state.commissions}
                        columns={columns}
                        options={{
                            ...this.state.CommissionsTable.options,
                            textLabels: {
                                body: { noMatch: this.state.commissionsLoading ? "LOADING..." : "No data available" },
                            },
                            selectableRows: "none",
                        }}
                        ref={this.tableRef}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

export default RakutenCommissionData;
